import { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";

import { ServiceConstants } from "constant";
import { CommentResponse } from "types";
import { AppUtils } from "utils";
import { IRootState } from "config/redux";

import Modal from '../base';
import CommentsList from "./list";
import { UserService } from "services";

const { REQUEST_PENDING, REQUEST_USER_COMMENTS_LIST_ID, REQUEST_USER_COMMENTS_CREATE_ID } = ServiceConstants;

interface CommentsModalProps {
  opened: boolean;
  incrementNumberOf?: () => void;
  onClose: () => void;
  title: React.ReactNode;
  userId: number;
}

const CommentsModal = ({ incrementNumberOf, opened, onClose, title, userId }: CommentsModalProps) => {

  const getCommentsServiceObject = useSelector((state: IRootState) => state.service.object[REQUEST_USER_COMMENTS_LIST_ID + userId]);
  const newCommentServiceObject = useSelector((state: IRootState) => state.service.object[REQUEST_USER_COMMENTS_CREATE_ID + userId]);

  const [comments, setComments] = useState<CommentResponse[] | undefined>(undefined);

  useEffect(() => {
    if (opened) getComments();
  }, [opened]);

  useEffect(() => {
    AppUtils.resolveServiceObject(getCommentsServiceObject, REQUEST_USER_COMMENTS_LIST_ID + userId, (val) => setComments([...val].reverse()));
    AppUtils.resolveServiceObject(newCommentServiceObject, REQUEST_USER_COMMENTS_CREATE_ID + userId, (val) => {
      setComments(old => ([val, ...old!]));
      if (incrementNumberOf) incrementNumberOf();
    });
  }, [getCommentsServiceObject, newCommentServiceObject]);

  const getComments = useCallback(() => UserService.userCommentsAll(userId), []);
  const createComment = useCallback((comment: string) => UserService.userCommentsCreate(userId, comment), []);

  const isLoadingGet = useMemo(() => getCommentsServiceObject && getCommentsServiceObject.status === REQUEST_PENDING, [getCommentsServiceObject])
  const isLoadingNew = useMemo(() => newCommentServiceObject && newCommentServiceObject.status === REQUEST_PENDING, [newCommentServiceObject])

  return (
    <Modal opened={opened} onClose={onClose} title={title} size={'xl'} >
      <CommentsList
        comments={comments}
        loadingList={isLoadingGet}
        postingComment={isLoadingNew}
        onSubmit={createComment}
      />
    </Modal>
  )
}

export default CommentsModal;